import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(routes)/blog/[slug]/_components/BlogPost.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
